import React, { useEffect, useState } from 'react';
import { useRequest } from 'umi';
import styles from '../css/dynamicCSS.less';
import { Button, Checkbox, Dropdown, Tabs } from 'antd';
import Dynamic from './dynamic';
import DynamiCenrollStudent from './dynamiCenrollStudent';
import { getCampNodes } from '@/services/ConsoleRequest';
import { CaretDownOutlined } from '@ant-design/icons';
import cx from 'classnames';

type Props = {
  campId: string;
  batchId?: string;
  nodeIds?: [];
  type?: number;
  selectNode?: boolean;
  hide?: boolean;
  newTabKey?: string;
};

const DynamicTabs: React.FC<Props> = (props) => {
  const [options, setOptions] = React.useState<any>();

  // 处理下拉
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedOptionsName, setSelectedOptionsName] = useState<string[]>([]);
  const [nodeIds, setNodeIds] = useState<string[]>([]);
  const [nodeNames, setNodeNames] = useState<string[]>([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [hash, setHash] = useState<number>(1);
  const [tabKey, setTabKey] = useState('1');
  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (props.newTabKey) {
      setTabKey(props.newTabKey);
    }
  }, [props.newTabKey]);

  // 获取节点接口
  const { run: resNodesRequest } = useRequest(
    (campId) => {
      return getCampNodes(campId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setOptions(res);
      },
    },
  );

  useEffect(() => {
    resNodesRequest(props.campId);
  }, [props.campId]);

  const Children = (selected: any, item: Props) => {
    if (item.type === 1) {
      return (
        <DynamiCenrollStudent
          key={hash}
          selected={selected}
          campId={item.campId}
          batchId={props.batchId}
          setTabKey={setTabKey}
          isFirst={isFirst}
          tabKey={tabKey}
        />
      );
    } else {
      return (
        <Dynamic
          key={hash}
          selected={selected}
          campId={item.campId}
          nodeIds={nodeIds}
          batchId={props.batchId}
          hide={props.hide}
          setTabKey={setTabKey}
          isFirst={isFirst}
        />
      );
    }
  };

  const handleCheckboxChange = (value: string) => {
    if (selectedOptions.includes(value)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== value));
      setSelectedOptionsName(
        selectedOptionsName.filter(
          (label) => label !== options.find((option: any) => option.id === value)?.name,
        ),
      );
    } else {
      setSelectedOptions([...selectedOptions, value]);
      setSelectedOptionsName([
        ...selectedOptionsName,
        options.find((option: any) => option.id === value)?.name,
      ]);
    }
  };

  const handleSubmit = () => {
    // console.log('提交的选项：', selectedOptions);
    // console.log('提交的选项：', selectedOptionsName);
    setNodeIds(selectedOptions);
    setNodeNames(selectedOptionsName);
    setIsDropdownVisible(false);
    setHash(hash + 1);
  };

  const handleCancel = () => {
    setNodeIds([]);
    setSelectedOptions([]);
    setSelectedOptionsName([]);
    setNodeNames([]);
    setIsDropdownVisible(false);
  };
  const handleSelectAll = () => {
    if (selectedOptions.length === options.length) {
      setSelectedOptions([]);
      setSelectedOptionsName([]);
    } else {
      setSelectedOptions(options.map((option: any) => option.id));
      setSelectedOptionsName(options.map((option: any) => option.name));
    }
  };

  const onTabChanged = (key: any) => {
    setIsFirst(false);
    setTabKey(key);
  };

  return (
    <div>
      <div className={cx(styles.dynamic_tabs_box, 'dynamic_tabs_box_m')}>
        <Tabs
          size="large"
          defaultActiveKey="1"
          activeKey={tabKey}
          destroyInactiveTabPane
          indicator={{ size: (origin) => origin - 26 }}
          onChange={onTabChanged}
          tabBarExtraContent={
            props.selectNode !== false ? (
              <div>
                <div>
                  <Dropdown
                    overlayClassName={styles.node_dropdown}
                    open={isDropdownVisible}
                    //onOpenChange={(isOpen) => {
                    //  setIsDropdownVisible(isOpen);
                    //}}
                    menu={{
                      items: Array.isArray(options)
                        ? [
                            {
                              label: <Checkbox onChange={handleSelectAll}>全选</Checkbox>,
                              key: '0',
                            },
                          ].concat(
                            options.map((option) => {
                              return {
                                label: (
                                  <Checkbox
                                    key={option.id}
                                    value={option.id}
                                    onChange={() => handleCheckboxChange(option.id)}
                                    checked={selectedOptions.includes(option.id)}
                                  >
                                    {option.name}
                                  </Checkbox>
                                ),
                                key: option.id,
                              };
                            }),
                          )
                        : [],
                    }}
                    trigger={['click']}
                    dropdownRender={(menu) => {
                      return (
                        <div className="com_prop" style={{ width: 200, marginRight: 16 }}>
                          <div className={cx('flex_8')}>{menu}</div>
                          <div
                            style={{
                              borderTop: '1px solid #e5e5e5',
                              textAlign: 'right',
                              padding: 8,
                              marginTop: 8,
                            }}
                          >
                            <Button className="f12" onClick={handleCancel}>
                              取消
                            </Button>
                            <Button
                              className="f12"
                              style={{ marginLeft: '8px' }}
                              type="primary"
                              onClick={handleSubmit}
                            >
                              确定
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  >
                    <div
                      className="col172"
                      style={{ textAlign: 'right', padding: '16px 16px 0 0' }}
                    >
                      <Button
                        type="text"
                        onClick={() => {
                          setIsDropdownVisible(!isDropdownVisible);
                        }}
                      >
                        <div style={{ maxWidth: 200, overflow: 'hidden' }} className="hide_txt">
                          {nodeNames.length > 0 ? nodeNames.join('、') : '全部节点'}
                          <CaretDownOutlined style={{ marginLeft: 4 }} />
                        </div>
                      </Button>
                    </div>
                  </Dropdown>
                </div>
              </div>
            ) : undefined
          }
          items={[
            {
              label: '精选动态',
              key: '1',
              children: Children(1, props),
            },
            {
              label: '所有动态',
              key: '2',
              children: Children(0, props),
            },
          ]}
        />
      </div>
    </div>
  );
};
export default DynamicTabs;
